import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import SearchableSelect from '../SearchableSelect';
import COUNTRIES from '../../data/countries';

const PROPERTY_TYPES = [
  'Land',
  'Studio apartment',
  '2 bed apartment',
  '3 bed apartment',
  '4 bed apartment',
  'Bungalow',
  'Terrace House',
  'Town house',
  'Semi-detached House',
  'Detached House',
  'Commercial Property'
];

const COUNTRY_OPTIONS = COUNTRIES.map(c => ({ value: c, label: c, searchKey: c }));

const RealEstateFields = ({ formData, onFieldChange }) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="property_country" className="portfolio-input-label">Country <span className="text-red-500">*</span></Label>
        <SearchableSelect
          value={formData.property_country}
          onValueChange={(value) => onFieldChange('property_country', value)}
          options={COUNTRY_OPTIONS}
          placeholder="Select country"
          searchPlaceholder="Search country..."
          emptyMessage="No country found."
          dataTestId="property-country-select"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="property_city" className="portfolio-input-label">City</Label>
        <Input
          id="property_city"
          placeholder="e.g. New York, London"
          value={formData.property_city}
          onChange={(e) => onFieldChange('property_city', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="property_street_address" className="portfolio-input-label">Street Address</Label>
        <Input
          id="property_street_address"
          placeholder="Street address"
          value={formData.property_street_address}
          onChange={(e) => onFieldChange('property_street_address', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="property_type" className="portfolio-input-label">Property Type</Label>
        <Select 
          value={formData.property_type} 
          onValueChange={(value) => onFieldChange('property_type', value)}
        >
          <SelectTrigger className="portfolio-input">
            <SelectValue placeholder="Select property type" />
          </SelectTrigger>
          <SelectContent>
            {PROPERTY_TYPES.map((propType) => (
              <SelectItem key={propType} value={propType}>{propType}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="property_date_acquired" className="portfolio-input-label">Date of Acquisition</Label>
        <Input
          id="property_date_acquired"
          type="date"
          value={formData.property_date_acquired}
          onChange={(e) => onFieldChange('property_date_acquired', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="property_purchase_price" className="portfolio-input-label">Purchase Price</Label>
        <Input
          id="property_purchase_price"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.property_purchase_price}
          onChange={(e) => onFieldChange('property_purchase_price', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="property_mortgage_outstanding" className="portfolio-input-label">Mortgage Outstanding (if any)</Label>
        <Input
          id="property_mortgage_outstanding"
          type="number"
          step="0.01"
          placeholder="0.00"
          value={formData.property_mortgage_outstanding}
          onChange={(e) => onFieldChange('property_mortgage_outstanding', e.target.value)}
          className="portfolio-input"
        />
      </div>
    </>
  );
};

export default RealEstateFields;
